import * as React from "react";

import { Section } from "../ui/atoms/section";
import { ListPedestrianEvents } from "../ui/molecules/list-pedestrian-events";
import { FilterByDateRange } from "../ui/organisms/filter-by-date-range";
import { SelectionMode } from "@fluentui/react";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

export class PagePedestrianActivity extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.pedestrianActivity.title")} classic>
                <Section fill>
                    <ListPedestrianEvents
                        commandBar={<FilterByDateRange onDateRangeChanged={() => {}} />}
                        selectionMode={SelectionMode.none}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
